module.exports = __webpack_public_path__ + "img/newschoolers.0afab23.png";